export default __webpack_public_path__ + "static/video-tumbnail-71198814a28a79d95a9a1f5ed8be0dbd.webp";